export default "__VITE_ASSET__DOjd3kAd__"